import type { AdminReviewDetail } from '@repo/api-contracts';
import type { ReactElement } from 'react';
import { formatDateTime } from '@/shared/lib';

interface ReviewHiddenHistoryProps {
  readonly hidden: NonNullable<AdminReviewDetail['hidden']>;
}

/** 숨김 이력 — 처리자·시각·사유(내부 메모). */
export const ReviewHiddenHistory = ({ hidden }: ReviewHiddenHistoryProps): ReactElement => (
  <section aria-label="숨김 이력" className="rounded-2xl bg-destructive/10 px-5 py-4 text-sm">
    <h2 className="font-medium text-destructive">숨김 이력</h2>
    <p className="mt-1 text-destructive">
      {hidden.byName} · {formatDateTime(hidden.at)}
    </p>
    <p className="mt-2 whitespace-pre-wrap">{hidden.reason}</p>
  </section>
);
